<template>
  <nav-bar title="付货" />
  <RoleName role="充装人员" />
  <Content :bottom="120" :top="98" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <div class="title">
      <span>{{ list[0] && list[0].departmentName }}</span>
      <span>实瓶</span>
      <span>{{ list.length }}</span>
    </div>
    <ul class="list">
      <li class="list-item list-title van-hairline--bottom">
        <span class="list-item__gsId">瓶号</span>
        <span class="list-item__residua-gas">重量</span>
        <span>
          <!-- <span>全选</span> -->
          <van-checkbox
            v-model="checkedAll"
            shape="square"
            @click="handleCheckedAllClick"
          />
        </span>
      </li>
      <van-checkbox-group v-model="checked" ref="checkboxGroup">
        <li
          class="list-item list-child"
          v-for="item in list"
          :key="item.gsCode"
        >
          <span class="list-item__gsId">{{ item.gsCode }}</span>
          <span class="list-item__residua-gas">{{ item.gsCapacity }}</span>
          <span>
            <van-checkbox :name="item.gsId" shape="square" />
          </span>
        </li>
      </van-checkbox-group>
    </ul>
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="getList"
    />
  </Content>
  <div v-if="!showLoading" class="btn-conatiner van-hairline--top">
    <van-row v-show="inputShow" gutter="16">
      <van-col span="24">
        <van-field
          ref="pdaCode"
          label="扫码结果"
          placeholder="请按动PDA上的扫码按钮"
          @update:model-value="pdaScan"
          v-model="resultStr"
        />
      </van-col>
    </van-row>
    <van-row gutter="16">
      <van-col span="24">
        <van-button
          block
          icon="scan"
          native-type="button"
          @click="handlePdaCodeClick"
        >
          PDA扫码
        </van-button>
      </van-col>
    </van-row>
    <van-button
      block
      type="primary"
      native-type="button"
      :loading="loading"
      :disabled="loading"
      loading-text="请稍后..."
      @click="handleSubmitClick"
    >
      付货<span v-show="checked.length">（{{ checked.length }}）</span>
    </van-button>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { computed, ref, nextTick } from 'vue'
import { cylinderSummaryDetail, payGoods } from '@/api/cylinderManageUserHome'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { useSubmit } from '@/hooks/useSubmit'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useChecked } from '@/hooks/useChecked'
export default {
  name: 'PayGoodsDetail', // 付货
  props: ['departmentId', 'applyId', 'appStatus', 'empId'],
  setup(props) {
    const data = useLoadingMore(cylinderSummaryDetail)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.departmentId = props.departmentId
      pageParams.applyId = props.applyId
      pageParams.appStatus = props.appStatus
      pageParams.empId = props.empId
      pageParams.summaryType = '1'
      pageParams.page = 1
      pageParams.pageNum = 15
      finished.value = false
      loadingFail.value = false

      getList()
    }
    init()

    // 选择钢瓶
    const { checkedAll, checked, checkboxGroup, handleCheckedAllClick } =
      useChecked(list)
    const aftCheck = ref('')
    // 提交
    const router = useRouter()
    const store = useStore()
    const empId = computed(() => store.state.roleInfo.empId)
    const operatorId = computed(() => store.state.userInfo.id).value
    const params = {
      gsIdList: [],
      operatorId,
      applyId: props.applyId,
      deptId: props.departmentId,
      empId: empId.value
    }
    const { loading, onSubmit } = useSubmit(payGoods, params, () => {
      router.back()
    })
    const handleSubmitClick = () => {
      if (checked.value.length) {
        params.gsIdList = checked.value
        onSubmit()
      } else {
        Toast('请选择需要付货的瓶号')
      }
    }
    // 检查表
    const checkPopup = ref(null)
    const handlePopClick = () => {
      checkPopup.value.showPopup()
    }
    const handleCheckConfirm = () => {
      checkPopup.value.hidePopup()
    }
    const inputShow = ref(false)
    const resultStr = ref('')
    const pdaCode = ref(null)
    const handlePdaCodeClick = async () => {
      inputShow.value = true
      await nextTick()
      if (pdaCode.value) {
        pdaCode.value.focus()
      }
    }
    const pdaScan = (v) => {
      const f = list.value.find((item) => item.qrCode === v)
      if (f && !checked.value.includes(f.gsCode)) {
        checked.value.push(f.gsCode)
      }
      resultStr.value = ''
    }
    return {
      radio: '1',
      list,
      checkedAll,
      checked,
      aftCheck,
      checkboxGroup,
      handleCheckedAllClick,
      loading,
      handleSubmitClick,
      checkPopup,
      handlePopClick,
      handleCheckConfirm,
      ...data,
      inputShow,
      pdaScan,
      handlePdaCodeClick,
      resultStr
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin: 16px;
  color: #666;
  font-size: 14px;
  span {
    margin-right: 5px;
  }
  span:last-child {
    font-weight: 600;
    color: #000;
  }
}
.list {
  font-size: 14px;
  padding: 0 16px;
  .list-item {
    display: flex;
    align-items: center;
    &__gsId {
      flex: 1;
    }
    &__residua-gas {
      margin: 0 50px 0 10px;
      width: 50px;
      text-align: right;
    }
  }
  .list-title {
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
  .list-child {
    margin-bottom: 10px;
    &:nth-child(odd) {
      background-color: #fff;
    }
    &:nth-child(even) {
      background-color: #ededed;
    }
  }
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
</style>
